import React from 'react'
import JobsPage from '@/components/pages/JobsPage/JobsPage'

const JobsPageContainer = () => {
    return <JobsPage />
}

export default JobsPageContainer